<template>
    <div>
        <span>
            {{ cTollStations }}
        </span>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  params: Object
})

const { params } = toRefs(props)

const cTollStations = computed(() => {
  const routingPositions = params?.value?.data?.routingPositions || {}
  const legs = routingPositions?.route?.legs || []

  const tollStations = legs.map((item: any) => item.tollStations || []).flat()

  const tollStationNames = tollStations.map((item: any) => item.locationName)

  const name = tollStationNames.join(' ,')
  return name
})
</script>
